<template>
  <div
    class="mx-auto Kanit"
    style="
      display: flex;
      flex-flow: column;
      position: absolute;
      height: 100%;
      max-width: 500px;
    "
  >
    <div
      class="primary pa-4 text-center white--text Kanit"
      style="font-size: 22px"
    >
      ข้อกำหนดและเงื่อนไข
    </div>

    <v-card
      class="ma-4 pa-3"
      style="overflow-y: scroll; font-size: 15px"
      color="#eee"
    >
      <div class="ALL-CONTENT-HERE Kanit" v-if="termCondition">
        <div v-html="termCondition.term_condition"></div>
      </div>
      <div>
        <v-checkbox
          style="font-weight: 600"
          label="ข้าพเจ้าได้อ่าน และยอมรับข้อตกลงและเงื่อนไข"
          v-model="cbagree"
        ></v-checkbox>
      </div>
    </v-card>

    <div class="pa-5 mb-3 pt-0">
      <v-btn
        @click="handleSubmitPdpa"
        :loading="saveloading"
        :disabled="!cbagree"
        style="font-size: 22px"
        class="text-capitalize"
        color="primary"
        :dark="cbagree"
        block
        >ยอมรับ</v-btn
      >
      <v-btn
        @click="$liff.closeWindow()"
        style="font-size: 22px"
        class="mt-3 text-capitalize"
        color="#eee"
        :loading="saveloading"
        block
        >ไม่ยอมรับ</v-btn
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["value"],
  data() {
    return {
      loading: false,
      saveloading: false,
      cbagree: false,
      termCondition: this.value,
    };
  },
  mounted() {},
  methods: {
    async handleSubmitPdpa() {
      const vm = this;
      try {
        vm.saveloading = true;
        let response = null;
          response = await vm.submitTermCondition();
        vm.saveloading = false;

        if (response && response.status === 200) {
          vm.$emit("onAgree");
        } else {
          await vm.$swal.fire({
            text: response.data.reason,
          });
          vm.$liff.closeWindow();
        }
      } catch (error) {
        console.error(error);
      }
    },
    async submitTermCondition() {
      const vm = this;
      try {
        const data = {
          userid: vm.userid,
          pageid: vm.query.pageid,
          term_condition_id: vm.termCondition.id,
        };

        const url = `${vm.serverUrl}toacrm/api/liff/pdpa`;
        const response = await axios.post(url, data, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        });

        if (response) {
          return response;
        } else {
          return null;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async submitpdpa() {
      const vm = this;
      try {
        const data = {
          userid: this.userid,
          pageid: this.query.pageid,
        };

        vm.saveloading = true;
        const url = `${vm.serverUrl}toacrm/pdpa`;
        const response = await axios.post(url, data, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        });
        vm.saveloading = false;

        if (response) {
          return response;
        } else {
          return null;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss">
html {
  height: 100%;
}
</style>
